// Constants mirrored from goalhorn-standalone-app/src/goalhorns/config.py.
// Keep in sync when the desktop format changes.

export const APP_NAME = "Goalhorns";
export const BUNDLE_FORMAT_VERSION = 2;
export const BUNDLE_EXT = ".goalhorns";
export const MANIFEST_NAME = "manifest.json";
export const BUNDLE_PHOTO_DIR = "photos";
export const BUNDLE_SONG_DIR = "songs";
export const BUNDLE_PREFIX_MIN_WIDTH = 2;
export const PHOTO_FALLBACK_NAME = "photo";
export const SONG_FALLBACK_NAME = "song";
export const MAX_COMPONENT_LEN = 80;
export const MAX_NAME_LEN = 60;
export const MAX_CELLS = 500;
export const MAX_HOTKEY_KEYS = 4;

export const MIN_LEN_S = 3;
export const MAX_LEN_S = 30;
export const MIN_VOLUME = 0;
export const MAX_VOLUME = 100;

export const LANGUAGES = ["en", "sr"] as const;
export const CELL_SIZES = ["S", "M", "L", "XL"] as const;
export const PHOTO_EXTENSIONS = [".png", ".jpg", ".jpeg"] as const;
export const AUDIO_EXTENSIONS = [".wav", ".flac", ".mp3", ".m4a", ".aac"] as const;

export const WINDOWS_ILLEGAL_CHARS = '<>:"/\\|?*';
export const WINDOWS_RESERVED_NAMES: ReadonlySet<string> = new Set([
  "CON",
  "PRN",
  "AUX",
  "NUL",
  ...Array.from({ length: 9 }, (_, i) => `COM${i + 1}`),
  ...Array.from({ length: 9 }, (_, i) => `LPT${i + 1}`),
]);

export const MODIFIER_ORDER = ["Ctrl", "Alt", "Shift", "Meta"] as const;
export const MODIFIER_ALIASES: ReadonlyMap<string, string> = new Map([
  ["CTRL", "Ctrl"],
  ["CONTROL", "Ctrl"],
  ["ALT", "Alt"],
  ["OPTION", "Alt"],
  ["SHIFT", "Shift"],
  ["META", "Meta"],
  ["CMD", "Meta"],
  ["COMMAND", "Meta"],
  ["WIN", "Meta"],
  ["SUPER", "Meta"],
]);
export const KEY_ALIASES: ReadonlyMap<string, string> = new Map([
  ["ESC", "Escape"],
  ["ESCAPE", "Escape"],
  ["SPACE", "Space"],
]);
export const MAX_F_KEY = 12;
export const RESERVED_KEYS: ReadonlySet<string> = new Set(["Escape", "F11"]);
export const RESERVED_COMBOS: readonly (readonly string[])[] = [
  ["Ctrl", "S"],
  ["Ctrl", "Shift", "S"],
  ["Ctrl", "O"],
  ["Ctrl", "F"],
  ["Ctrl", "Q"],
  ["Ctrl", "W"],
  ["Ctrl", "Meta", "F"],
];
